import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=220ac016&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style1 from "./Index.vue?vue&type=style&index=1&id=220ac016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ac016",
  null
  
)

export default component.exports